<template>
  <div class="bg-white">
  </div>
</template>

<script>
import accountMixin from '@/mixins/account.mixin'

export default {
  mixins: [accountMixin],
  created () {
    this.$store.commit('setLoading', true)
    this.logOff()
    this.$store.commit('setLoading', false)
  }
}
</script>

<style lang="scss" scoped>
.bg-white {
  position: fixed;
    height: 100vh;
    top: -20px;
    width: 100vw;
    left: 0;
    z-index: 100000;
    background-color: $body-bg;
} 
</style>


// WEBPACK FOOTER //
// src/components/views/account/SignedOut.vue